import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { Checkroom as Icon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Merchandising({ selected, onSelect, open }: Props) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/merchandising"
			selected={selected === MenuItem.Merchandising}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Merchandising)}
		>
			<ListItemIcon>
				<Icon />
			</ListItemIcon>
			{open && <ListItemText primary={t('merch:merchandising')} />}
		</ListItem>
	);
}
